export const nhsProductReducer = (
	state = {
		list: undefined,
		count: 0,
		productData: [],
		productsDetails: undefined,
		detail: undefined,
		productDropDownData: []
	},
	action
) => {
	switch (action.type) {
		case "NHS_PRODUCT_LIST_SUCCESS":
		case "NHS_PRODUCT_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				productData: action.payload.productData,
			};
		case "NHS_PRODUCT_DROPDOWN_LIST_SUCCESS":
			console.log(action?.payload?.page == 1, [...state?.productDropDownData, ...action.payload.list], "[...state?.productDropDownData, ...action.payload.list]	")
			return {
				...state,
				productDropDownData: action?.payload?.page == 1 ||!action?.payload?.page  ? action.payload?.list : [...state?.productDropDownData, ...action.payload.list],
			};

		
		
		case "NHS_PRODUCT_TOGGLE_SUCCESS":
			return {
				...state,
				productsDetails: { ...state?.productsDetails, isActive: !state?.productsDetails?.isActive },
			};
		case "NHS_PRODUCT_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
